'use strict';

const init = () => {
    if (document.querySelector('.tc-website-socialshare')) {
        document.querySelector('.social-share-button.facebook').addEventListener('click', () => {
            const url = `https://www.facebook.com/sharer/sharer.php?u=${getPageUrl()}`;
            window.open(url, '_blank', 'width=600,height=400');
        })

        document.querySelector('.social-share-button.linkedin')?.addEventListener('click', () => {
            const url = `https://www.linkedin.com/sharing/share-offsite/?url=${getPageUrl()}`;
            window.open(url, '_blank', 'width=900,height=700');
        })

        document.querySelector('.social-share-button.email').addEventListener('click', () => {
            const subject = encodeURIComponent("Regarde cet article !");
            const body = encodeURIComponent(`J'ai trouvé cet article intéressant : ${window.location.href}`);
            window.location.href = `mailto:?subject=${subject}&body=${body}`;
        })
    }
}

const getPageUrl = () => {
    return encodeURIComponent(window.location.href);
}

export default {init}
